import {Component, AfterViewInit, OnInit, Input} from '@angular/core';
import { Router } from '@angular/router';

/*import { Chart } from 'chart.js';*/
//2026-04-08 commenting out Chart from chart.js for now to help remediate CommonJS dependencies.  This isn't used anyway, and chart.js is causing build warnings.
//If charts are needed sometime in the future, ng2-charts is a possibility

@Component({
    selector: 'chart-widget',
    templateUrl: './chart-widget.component.html',
    standalone: false
})

export class ChartWidget implements OnInit, AfterViewInit  {
    @Input() widgetTitle: string;

    
    canvas: any;

    constructor(public router: Router) {}

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.canvas = document.getElementById('myChart');
        //let myChart = new Chart(this.canvas, {
        //    // The type of chart we want to create
        //    type: 'line',

        //    // The data for our dataset
        //    data: {
        //        labels: ["January", "February", "March", "April", "May", "June", "July"],
        //        datasets: [{
        //            label: "My First dataset",
        //            backgroundColor: 'rgb(255, 99, 132)',
        //            borderColor: 'rgb(255, 99, 132)',
        //            data: [0, 10, 5, 2, 20, 30, 45],
        //        }]
        //    },

        //    // Configuration options go here
        //    options: {
        //        maintainAspectRatio: false
        //    }
        //});
    }
}